import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { getTexturedSVG } from "@/utilities/SVGPreview";
import { makerjs } from "../../../source/js/shared/rendering/makerjs";
import OptionSelector from "@/components/UI/OptionSelector.vue";
import OptionSelectorWrapper from "@/components/UI/OptionSelectorWrapper.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SideToggle',
  props: {
    value: {},
    name: {},
    idPrefix: {}
  },
  setup(__props: any) {

const props = __props;

const i18n = window.measurementSelectorVariables.i18n;
const front = computed(() => {
	return i18n.sideSelection.settings.topSide;
});
const back = computed(() => {
	return i18n.sideSelection.settings.backSide;
});

const svgFront = computed(() => {
	return getTexturedSVG(
		getRectangle(),
		front.value.color,
		front.value.appearance,
		"xMinYMin slice"
	);
});

const svgBack = computed(() => {
	return getTexturedSVG(
		getRectangle(),
		back.value.color,
		back.value.appearance,
		"xMinYMin slice"
	);
});

function getRectangle() {
	const rectangle = new makerjs.models.Rectangle(170, 120);

	// @ts-expect-error rectangle is an instance of IModel
	rectangle.layer = "shape";
	return makerjs.exporter.toSVG(rectangle, {
		useSvgPathOnly: true,
		stroke: "none",
	});
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(OptionSelectorWrapper, null, {
    default: _withCtx(() => [
      _createVNode(OptionSelector, {
        "is-active": _ctx.value === 'topSide',
        value: "topSide",
        image: svgFront.value,
        rawImage: true,
        label: front.value.label,
        onInput: () => _ctx.$emit('input', 'topSide'),
        name: "measurements[side_selection]",
        activeValue: _ctx.value
      }, null, 8, ["is-active", "image", "label", "onInput", "activeValue"]),
      _createVNode(OptionSelector, {
        "is-active": _ctx.value === 'backSide',
        value: "backSide",
        image: svgBack.value,
        rawImage: true,
        label: back.value.label,
        onInput: () => _ctx.$emit('input', 'backSide'),
        name: "measurements[side_selection]",
        activeValue: _ctx.value
      }, null, 8, ["is-active", "image", "label", "onInput", "activeValue"])
    ]),
    _: 1
  }))
}
}

})